import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DialogEmailDetailComponent } from '../dialog-email-detail/dialog-email-detail.component';

@Component({
  selector: 'app-dialog-email-status',
  templateUrl: './dialog-email-status.component.html',
  styleUrls: ['./dialog-email-status.component.scss']
})
export class DialogEmailStatusComponent implements OnInit {
  waitingForData = [];

  columnsToDisplay: string[] = [];

  emailData: any;

  constructor(
    public dialogRef: MatDialogRef<DialogEmailStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.columnsToDisplay = [this.translate.instant('email_sender'), this.translate.instant('email_subject'), this.translate.instant('email_date'), this.translate.instant('email_status')];
    this.emailData = this.data.emailData.map((email: { sent: boolean }) => ({
      ...email,
      sentLabel: this.translate.instant(email.sent ? 'email_sent' : 'email_not_sent')
    }));
  }

  openDetail(email: { id: string }): void {
    this.dialog.open(DialogEmailDetailComponent, {
      data: { id: email.id },
      width: '760px',
      maxWidth: '94vw',
      autoFocus: false
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
